export interface ReminderInterface {
  /**
   * 验证码 id ，用于在验证时进行比对
   */
  reminderId: string
}

export class Reminder implements ReminderInterface {
  /**
   * 验证码 id ，用于在验证时进行比对
   */
  reminderId: string

  constructor(props: ReminderInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      reminderId: _reminderId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.reminderId = _reminderId
  }
}
